import {Card, Col, Row, Space, Tooltip, Typography} from "antd";
import TickerChip from "../../components/TickerChip";
import Button from "@mui/material/Button";
import {SquareRounded} from "@mui/icons-material";
import {etfGroupConfig} from "../../configs/tickerConfigs";
import React from "react";

const TickerManager = ({ tickers, onRemove }) => {
    return (
        <Card style={{ maxHeight: '70vh', overflowY: 'scroll' }}
              bordered={false}
              title={<Typography.Title level={4}>Selected Tickers</Typography.Title>}
        >
            <Space direction="vertical">
                {tickers.map((ticker, index) => (
                    <Row key={ticker.symbol} justify={'space-between'} wrap={false} align={'middle'}>
                        <Col style={{ maxWidth: '280px' }}>
                            <TickerChip ticker={ticker} width={280} />
                        </Col>
                        <Col>
                                <Button variant="text" color="primary" >
                                    {ticker.groupName && <Tooltip title={`Group: ${ticker.groupName}`}><SquareRounded style={{ color: etfGroupConfig.find(x => x.title === ticker.groupName)?.color }} sx={{ fontSize: '16px' }} /></Tooltip>}
                                </Button>
                                <Button variant="outlined" color="secondary" onClick={() => onRemove(ticker.symbol)}>Remove</Button>
                        </Col>
                    </Row>
                ))}
            </Space>
        </Card>
    );
};

export default TickerManager;

